module.exports = __webpack_public_path__ + "static/media/loadingGIF.df926d38.gif";